var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loaded && _vm.user.id)?_c('nav-bar'):_vm._e(),(_vm.loaded)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e(),(_vm.processing || !_vm.loaded)?_c('block-ui'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }